import React, { type Ref } from 'react';

import { Label, type TypeLabelProps } from '@thefarmersfront/kitchen';

import clsx from 'clsx';

import styles from './FormField.module.scss';

type TypeFormFieldProps = {
  /** 라벨 텍스트 */
  label: string;
  /** 필수 여부 */
  required?: boolean;
  /** 툴팁 */
  tooltip?: TypeLabelProps['tooltip'];
  /** 컨텐츠 */
  contents: React.ReactNode;
  /** 컨텐츠 vertical 정렬 방향 */
  contentAlign?: 'start' | 'center';
  /** 라벨 클래스명 */
  labelClassName?: string;
  /** 컨텐츠 클래스명 */
  contentsClassName?: string;
  /** 전체 컨테이너 클래스명 */
  className?: string;
  ref?: Ref<HTMLDivElement>;
};

const FormField = ({
  label,
  required = false,
  tooltip,
  contents,
  contentAlign = 'start',
  labelClassName,
  contentsClassName,
  className,
  ref,
}: TypeFormFieldProps) => {
  return (
    <div ref={ref} className={`${styles['form-field']} ${className ?? ''}`}>
      <Label
        className={`${styles['label']} ${labelClassName ?? ''}`}
        title={label}
        required={required}
        tooltip={tooltip}
      />
      <div
        className={clsx(
          styles['contents-wrapper'],
          contentAlign === 'center' && styles['align-center'],
          contentsClassName
        )}
      >
        {contents}
      </div>
    </div>
  );
};

export default FormField;
